import cjson from 'compressed-json';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, SubscriptionLike, Subject } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { CallStage } from 'src/app/enums/CallStage';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';
import { JdDataService } from 'src/app/jd-data.service';
import { Location } from '@angular/common';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';

@Component({
    selector: 'app-report-company',
    templateUrl: './report-company.component.html',
    styleUrls: ['./report-company.component.scss'],
    standalone: false
})
export class ReportCompanyComponent implements OnInit {

  talentfilterdata: any = {};
  subscriptionsLike: SubscriptionLike[] = [];
  totalResultCount: number;
  start: number = 0;
  end: number = 10;
  currentCompanyData: any = []
  currentcompanies: any;
  @ViewChild('companysort') companysort: MatSort;
  displayedColumns: string[] = ['key', 'doc_count', 'attrition', 'oneyeargrowth', 'job_doc_count', 'median_salary', 'graph'];
  aggregatescount: number = 50;
  totalCount: number = 0;

  isApiCalled: boolean = false;
  currentPage: number = 1;
  pageSize: number = 10;
  companyarray: any[] = [];

  subscriptions: Array<Subscription> = [];

  /**Sorted data for all intital pages */
  comapniesSortData: any;
  /**Attrition data called or or not*/
  hasAttritionData: boolean = false;
  /** Diversity data called or not*/
  hasDiversityData = false;
  hasoneyeargrowth: boolean = false;
  companydataAI: any

  insightsExportSubscription: Subscription = null;
  primaryCompanyInformation: any = {};

  /**
   * Mapping of key and text value of headers
   * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
   */
  tableHeaderObj = {
    "TopCompanies": "Top Companies",
    "TalentCount": "Talent Count",
    "Attrition": "1 yr Attrition",
    "Growth": "1 yr Growth",
    "JobDemand": "Job Posts",
    "MedianSalary": "Salary Range",
    "DiversityRatio": "Diversity Ratio"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  combinedSkills: any[] = [];
  combinedJobtitle: any[] = [];
  combinedLocation: any[] = [];
  combinedIndustry: any[] = [];
  hasJobDemand: boolean = false;
  currencyData: any;
  selectedCurrency: any;
  target_currency_rate: number = 1;
  target_fav_icon: string = 'fa-dollar-sign';
  currency_symbol: string = '$';
  filteredCurrencies: any[] = [];
  hasMedianSalary: boolean = false;


  get isLocationEurope() {
    const hasEUTalentInsightsAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    const hasEUPSAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess')


    if (!hasEUPSAccess)
      return this.localstorageservice.getItem('talentRegion') == 'europe';
  }
  combinedAggregates: any;
  currency: string = null;
  aiSuggestions: any;
  filterData: any;
  companyJobAggregates: any;
  filterType: string[] = [];
  isComingFromJD: Boolean = false;
  isComingFromNLSearch: Boolean = false;
  sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  companyTabPayload:any
  hasJobListingAccess:any;
  filters: any;

  constructor(private personsearchservice: PersonSearchService, private localstorageservice: LocalStorageService, private router: Router
    , private talentInsightsReqHandlerService: TalentInsightsReqHandlerService, private aggReqObjectHandlerService: AggReqObjectHandlerService
    , private filterDataHandlerService: FilterDataHandlerService, private aggService: AggregationService, private talentInsightsService: TalentInsightsService
    , private hashService: HashService, private jdService: JdDataService, private route: ActivatedRoute, private location: Location) {
    const statemanagementSub = this.location.subscribe((p) => {
      const urlParams = new URLSearchParams(p.url.split('?')[1]);
      const filterKey = urlParams.get('filter');

      if (filterKey) {
        const cacheRequest = localStorage.getItem(filterKey);
        if (cacheRequest) {
          const filterData = cjson.decompress(JSON.parse(cacheRequest));
          this.filterDataHandlerService.setFilterData(filterData);
          // console.log('Decompressed Filter Data:', filterData);
        }
      }
      this.setUpdatedData();

    });
    this.subscriptionsLike.push(statemanagementSub);
  }

  ngOnInit() {
    if (this.jdService.isComingFromJobDescription) this.isComingFromJD = true;
    if (this.jdService.isComingFromNLSearch) this.isComingFromNLSearch = true;
    this.currentPage = 1;
    this.getCurrencyData();
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      this.filterData = _methodDetails
      this.getCurrencyData('filterChange');
    });
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);

    const jdUpdateEvent = this.jdService.getInsightsEvent().subscribe((res: any) => {
      if (res.action == 'refresh' && res.tab == this.talentInsightsService.INSIGHTS_TABS.COMPANY) {
        this.filterType = res.filterType;
        this.getCurrencyData('jdUpdate');
      }
    });
    const aiSuggestionSub = this.talentInsightsService.aiSuggesionData.subscribe(data => {
      this.aiSuggestions = data;
      if (!this.aiSuggestions) {
        this.aiSuggestions = this.talentInsightsService.getAISuggestionData();
      }
      this.getCurrencyData('filterChange');
    });
    this.subscriptions.push(aiSuggestionSub);
     this.hasJobListingAccess = this.localstorageservice.getItem('hasjoblistingaccess')
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) {
      this.talentfilterdata = talentFilterData;
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = this.currentPage > 1 ? this.currentPage : 1;
    this.getcurrentcompany();
    this.personsearchservice.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)

  }

  getcurrentcompany() {
    this.comapniesSortData = this.comapniesSortData?.map(res => {
      res.female = "";
      res.male = "";
      return res;
    });
    this.hasDiversityData = true;
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_company';
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();

    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq, true).subscribe((response) => {
      this.isApiCalled = true;
      this.totalResultCount = response.data.totalresultscount;

      const tempData = response.data.aggregations.current_company;
      this.companyarray = _.pluck(tempData, 'key')
      this.comapniesSortData = tempData;
      this.totalCount = tempData.length;
      this.currentCompanyData = tempData.slice(this.start, this.end);
      this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
      this.currentcompanies.sort = this.companysort;
      this.hasAttritionData = false;
      this.hasoneyeargrowth = false;
      this.getcurrentcompanydiversity();
      this.getrecentattrition();
      this.getoneyeargrowth()
      this.manualSort();
      if ((!this.filterData && this.filterType?.length == 0) || (this.filterData?.filterType == 'location' || this.filterData?.filterType == 'industry' || this.filterData?.filterType == 'company' || this.filterData?.filterType == 'seniority' || this.filterData?.filterType == 'function' || this.filterData?.filterType == 'locationRange' || this.filterData?.filterType == 'skills' || this.filterData?.filterType == 'jobtitle' || this.filterData?.filterType == 'keyword' || this.filterData?.filterType == 'search' || this.filterData?.filterType == 'pastjobtitle')
        || ((this.filterType?.length > 0 && (this.filterType?.includes('skills') || this.filterType?.includes('jobtitle') || this.filterType?.includes('industry') || this.filterType?.includes('company'))))) {

        this.getCurrency();
      } else if (this.filterData?.filterType == 'allfilters' && !this.isComingFromJD && !this.isComingFromNLSearch) {
        this.comapniesSortData.map(company => {
          company.median_salary = "N/A";
          company.confidence_score = "N/A";
          company.job_doc_count = 0;
          return company;
        });
        this.localstorageservice.setItem('jobCurrency', 'USD');
        this.localstorageservice.setItem('currencyCountry', null);
        this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
          this.currencyData = response?.data;
          this.filteredCurrencies = this.currencyData.slice(0, 5);
          const currency = this.localstorageservice.getItem('jobCurrency');
          if (currency) {
            const selectedCurrency = this.currencyData.find((x: any) => x.target_currency === currency);
            if (selectedCurrency) {
              this.selectedCurrency = selectedCurrency;
              this.target_currency_rate = selectedCurrency.rate;
              this.currency = selectedCurrency.target_currency;
              this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
              this.currency_symbol = selectedCurrency.target_currency_symbol;
            }
          }
        })
      } else {
        this.setcompanyJobAggregates();
      }

    });
  }

  getCurrentcompanypercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  getdiversitypercentage(value, doc_count) {
    return ((value / doc_count) * 100).toFixed(0);
  }

  manualSort() {
    this.reSortArr(this.companysort);
  }

  reSortArr(sort) {
    const tempData = this.comapniesSortData;
    if (!sort || !sort.active || sort.direction === '') {
      this.currentCompanyData = tempData.slice(this.start, this.end);
      this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
      this.currentcompanies.sort = this.companysort;
      return;
    }
    this.comapniesSortData = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'attrition': return this.compare(a.attrition, b.attrition, isAsc);
        case 'percentage': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.male, b.male, isAsc);
        case 'oneyeargrowth': return this.compare(a.oneyeargrowth, b.oneyeargrowth, isAsc);
        case 'job_doc_count': return this.compare(a.job_doc_count, b.job_doc_count, isAsc);
      }
    })

    this.currentCompanyData = tempData.slice(this.start, this.end);
    this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
    this.currentcompanies.sort = this.companysort;
  }

  compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    this.manualSort();

  }

  getcurrentcompanydiversity() {
    this.comapniesSortData = this.comapniesSortData.map(res => {
      res.female = "";
      res.male = "";
      return res;
    });
    this.hasDiversityData = true;

    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_company-gender';
    aggReq.searchviaboolean = true;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.companyarray;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq, true).subscribe((response) => {
      this.hasDiversityData = false;
      const tempData = response.data.aggregations['current_company-gender'];
      this.comapniesSortData.map(res => {
        const gender = tempData.filter(x => x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        if (gender && gender.gender && gender.gender.length > 0) {
          const femalecount = gender.gender.filter(x => x.key == "female") && gender.gender.filter(x => x.key == "female").length > 0 ? gender.gender.filter(x => x.key == "female")[0].doc_count : 0;
          const malecount = gender.gender.filter(x => x.key == "male") && gender.gender.filter(x => x.key == "male").length > 0 ? gender.gender.filter(x => x.key == "male")[0].doc_count : 0;
          const totalgendercount = femalecount + malecount
          res.female = femalecount ? (this.getdiversitypercentage(femalecount, totalgendercount)) : 0

          res.male = malecount ? this.getdiversitypercentage(malecount, totalgendercount) : 0;

        }
        return res;
      })
      this.getcompanydataai(this.comapniesSortData)

    });
  }

  getrecentattrition() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'lastcompany';
    aggReq.searchviaboolean = true;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.companyarray;
    aggReq.companytype = 'Past';
    aggReq.recentcompanyattrition = true;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq, true).subscribe((response) => {
      const tempData = response.data.aggregations.lastcompany;
      this.hasAttritionData = true
      this.comapniesSortData.map(res => {
        const pastcompany = tempData.filter(x => x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        res.attrition = pastcompany && pastcompany.doc_count ? pastcompany.doc_count : 0;
        return res;
      })
      this.getcompanydataai(this.comapniesSortData)
      //  this.totalCount = this.totalResultCount;
      //  this.currentCompanyData = tempData;
      //  this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
      //  this.currentcompanies.sort = this.companysort;
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getoneyeargrowth() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_company';
    aggReq.searchviaboolean = true;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.companyarray;
    aggReq.companytype = 'Current';
    aggReq.recentcompanyhires = true;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq, true).subscribe((response) => {
      const tempData = response.data.aggregations.current_company;
      this.hasoneyeargrowth = true;
      this.comapniesSortData.map(res => {
        const currentcompany = tempData.filter(x => x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        res.oneyeargrowth = currentcompany && currentcompany.doc_count ? currentcompany.doc_count : 0;
        return res;
      })
      this.getcompanydataai(this.comapniesSortData)
      //  this.totalCount = this.totalResultCount;
      //  this.currentCompanyData = tempData;
      //  this.currentcompanies = new MatTableDataSource(this.currentCompanyData);
      //  this.currentcompanies.sort = this.companysort;
    });
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    if (this.isLocationEurope) return;
 this.filters = this.filterDataHandlerService.fetchFilterData;

      const redirectFilters: Partial<FilterParams> = {
        insightsFilterData: this.filters,
      };

    switch (type) {
      case 'company': redirectFilters['mandatorycompanies'] = [key]; break;
      case 'recentcompanyhires': {
        redirectFilters['recentcompanyhires'] = true;
        redirectFilters['mandatorycompanies'] = [key];
        break;
      }
      case 'recentcompanyattrition': {
        redirectFilters['recentcompanyattrition'] = true;
        redirectFilters['mandatorycompanies'] = [key];
        break;
      }
    }

   const aggReq = this.aggService.getRequestWithFilters();
         if (aggReq?.continentstobeincluded) {
           redirectFilters['continentstobeincluded'] = aggReq.continentstobeincluded;
         }
         if (aggReq?.nlsearchquery) {
           redirectFilters['nlsearchquery'] = aggReq.nlsearchquery;
         }

         const uniqueKey = this.hashService.generateUniqueHash();
         localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

         // Forward the SAME UNIQUE_HASH this page was loaded with, so the listing page's
         // jdDataFromSession getter finds job_description-${jdUniqueHash} in the sessionStorage
         // that window.open() clones into the new tab.
         const jdUniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);

         let url = `/candidate-list?type=search&redirectSource=talent-insights&key=${uniqueKey}`;

         if ((this.isComingFromJD || this.isComingFromNLSearch) && jdUniqueHash) {
           url += `&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${jdUniqueHash}`;
         }

         window.open(url, '_blank');

  }

  getcompanydataai(data) {
    let companiesdata: any;
    companiesdata = data.map(x => {
      let res: any = {};
      res['Top Companies'] = x.key;
      res['Talent Count'] = x.doc_count;
      res['1 yr Attrition'] = x.attrition;
      res['1 yr Growth'] = x.oneyeargrowth;
      res['% of Total'] = this.getCurrentcompanypercentage(x.doc_count) + '%';
      res['Male'] = x.male + '%';
      res['Female'] = x.female + '%';
      res['Job Posts'] = x.job_doc_count || 0;
      if (x.median_salary_max != null) {
        res['median salary offered max'] = x.median_salary_max;
      }
      if (x.median_salary_min != null) {
        res['median salary offered min'] = x.median_salary_min;
      }
      if (this.selectedCurrency?.target_currency) {
        res['Salary currency'] = this.selectedCurrency?.target_currency;
      }

      return res;
    })
    this.modifyCurrencyDataForAi(companiesdata);
    this.companydataAI = {
      companies: companiesdata
    }
    if (companiesdata.length == 0)
      this.companydataAI = null;
  }

  /**
 * Format currency data
 * @param aiData Already formatted ai data
 * @returns
 */
  modifyCurrencyDataForAi(aiData) {
    if (!aiData || !Array.isArray(aiData)) {
      return;
    }
    aiData.forEach(item => {
      if (item['median salary offered max']) {
        item['median salary offered max'] = item['median salary offered max'] * this.target_currency_rate;
      }
      if (item['median salary offered min']) {
        item['median salary offered min'] = item['median salary offered min'] * this.target_currency_rate;
      }
      if (this.selectedCurrency?.target_currency) {
        item['Salary currency'] = this.selectedCurrency?.target_currency
      }
    })
  }


  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if (requestData?.data?.currentTab !== this.talentInsightsService.INSIGHTS_TABS.COMPANY) return;

    // Order must be as same as HTML and given name of diversity required in pdf
    this.tableHeaderName = [this.tableHeaderObj['TopCompanies'], this.tableHeaderObj["TalentCount"], this.tableHeaderObj["Attrition"], this.tableHeaderObj["Growth"], this.tableHeaderObj['JobDemand'], this.tableHeaderObj['MedianSalary'], 'Diversity Ratio (M | W)'];
     const companyDataForExport = this.comapniesSortData.map(company => {
      return {
        ...company,
        job_doc_count: company.job_doc_count || '—',
        median_salary: company.median_salary != 'N/A' ? company.median_salary : '—',
      }
    });
    const payloadForInsightsExport = {
      tab: 'company',
      totalresultcount: this.totalResultCount,
      companies: companyDataForExport,
      tableHeader: this.tableHeaderName,
      currencySymbol: this.currency_symbol
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getCompanyInfo(companyname) {
    let companyData = [];
    if (companyname) {
      companyData = [{
        name: companyname
      }]
    }
    companyData?.length &&
      this.personsearchservice.getCompanyLogoV2(companyData).subscribe((res: any) => {
        if (res.status == 'success' && res.data) {
          let companyDetails = res.data[0]
          this.primaryCompanyInformation['website'] = companyDetails.website ? companyDetails.website : null;
          this.primaryCompanyInformation['name'] = companyDetails.name ? companyDetails.name : null;
          this.primaryCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : null;
          this.primaryCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : null;
          this.primaryCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : null;
          this.primaryCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : null;
          this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
          this.primaryCompanyInformation['id'] = companyDetails.id
          this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
          this.primaryCompanyInformation['key_id'] = companyDetails.id
          this.primaryCompanyInformation['twitter_url'] = companyDetails.twitter_url ? companyDetails.twitter_url : null;
          this.primaryCompanyInformation['github_url'] = companyDetails.github_url ? companyDetails.github_url : null;
          this.primaryCompanyInformation['facebook_url'] = companyDetails.facebook_url ? companyDetails.facebook_url : null;

        }
      });
  }

  getCombinedAggregates() {
    this.hasJobDemand = true;
    this.hasMedianSalary = true;
    this.comapniesSortData = this.comapniesSortData.map(company => {
      company.median_salary = "";
      company.confidence_score = "";
      company.job_doc_count = "";
      return company;
    });
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'jobs_base_aggregates';
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();

    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.aggregatescount = 50;
    this.personsearchservice.getTotalAggs(aggReq).subscribe(response => {
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
      this.combinedLocation = this.combinedAggregates['location'];
      this.combinedIndustry = this.combinedAggregates['current_industry'];
      this.getJobsAggregates();
    });
  }


  getJobsAggregates() {
    this.hasMedianSalary = true;
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions')
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'company-median_salary',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations|| [],
      industries: aggReq?.industries|| [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
        excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
    }
    if (this.isComingFromJD || this.isComingFromNLSearch) {
      payload['jobDescriptionKeys'] = {
        jobtitles: jobtitles,
        mandatory_jobtitles: aggReq?.job_description_keys?.mandatory_job_titles || [],
        skills: skills,
        mandatory_skills: aggReq?.job_description_keys?.mandatory_skills || [],
        locations: aggReq?.job_description_keys?.locations || [],
        mandatory_locations: aggReq?.job_description_keys?.mandatory_locations || [],
        mandatory_company_sizes: aggReq?.job_description_keys?.mandatory_company_sizes || [],
        companies: aggReq?.job_description_keys?.companies || [],
        mandatory_companies: aggReq?.job_description_keys?.mandatory_companies || [],
        industries: aggReq?.job_description_keys?.industries || [],
        mandatory_industries: aggReq?.job_description_keys?.mandatory_industries || []
      }
      payload.jobtitles = _.uniq(aggReq?.jobtitles.concat(aggReq?.pastjobtitles)) || [];
      payload.skills = _.uniq(aggReq?.preferredskills?.concat(aggReq?.mandatoryskills)) || [];
    }
        this.companyTabPayload = payload

    if (jobtitles?.length > 0 && skills?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.hasJobDemand = false;
        this.hasMedianSalary = false;
        this.setcompanyJobAggregates();
        this.getcompanydataai(this.comapniesSortData);
      } else if (!this.isComingFromJD && !this.isComingFromNLSearch && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')) {
        this.hasJobDemand = false;
        this.hasMedianSalary = false;
        this.setcompanyJobAggregates();
        this.getcompanydataai(this.comapniesSortData);
      }


      else {
        this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
          const tempData = response?.data?.aggregations['company-median_salary'];
          this.companyJobAggregates = tempData;
          this.hasJobDemand = false;
          this.hasMedianSalary = false;
          this.setcompanyJobAggregates();


          this.getcompanydataai(this.comapniesSortData);
        })
      }
    } else {
      this.hasJobDemand = false;
      this.hasMedianSalary = false;
      this.setcompanyJobAggregates();
      this.getcompanydataai(this.comapniesSortData);
    }
  }

  formatNumber(value: number): string | number {
    if (value === null || value === undefined || isNaN(value)) return '0';

    const country = this.localstorageservice.getItem('currencyCountry');
    const absNum = Math.abs(value);

    // Optional: you can fetch dynamically if you store currency symbol
    const currencySymbol = country?.toLowerCase() === 'india' ? '₹' : '$';

    const format = (num: number) => {
      return num % 1 === 0 ? num.toString() : num.toFixed(1);
    };

    if (country?.toLowerCase() === 'india') {

      if (absNum >= 1e7) { // 1,00,00,000
        return format(value / 1e7) + 'Cr';
      }

      if (absNum >= 1e5) { // 1,00,000
        return format(value / 1e5) + 'L';
      }

      if (absNum >= 1e3) {
        return format(value / 1e3) + 'K';
      }

      return value;
    }

    else {

      if (absNum >= 1e9) {
        return format(value / 1e9) + 'B';
      }

      if (absNum >= 1e6) {
        return format(value / 1e6) + 'M';
      }

      if (absNum >= 1e3) {
        return format(value / 1e3) + 'K';
      }

      return value;
    }
  }


  getCurrency() {
    this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      this.filteredCurrencies = this.currencyData.slice(0, 5);
      const currency = this.localstorageservice.getItem('jobCurrency');
      if (currency) {
        const selectedCurrency = this.currencyData.find((x: any) => x.target_currency === currency);
        if (selectedCurrency) {
          this.selectedCurrency = selectedCurrency;
          this.target_currency_rate = selectedCurrency.rate;
          this.currency = selectedCurrency.target_currency;
          this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
          this.currency_symbol = selectedCurrency.target_currency_symbol;
        }
      }
      this.getJobsAggregates();

    })
  }

  onTypeAheadSearch(event: any) {
    const input = event.target.value.toLowerCase();
    this.filteredCurrencies = this.currencyData.filter(x => x.target_currency.toLowerCase().includes(input));
    this.filteredCurrencies = this.filteredCurrencies.slice(0, 5);
  }

  selectedItem(currencyItem: any) {
    this.selectedCurrency = currencyItem;
    this.target_currency_rate = currencyItem.rate;
    this.target_fav_icon = currencyItem.target_currency_fav_icon;
    this.currency = currencyItem.target_currency;
    this.currency_symbol = currencyItem.target_currency_symbol;
    this.localstorageservice.setItem('jobCurrency', this.currency);

    this.comapniesSortData = this.comapniesSortData.map(company => {
      if (this.target_fav_icon == 'fa-money-bill') {
        company.median_salary = company.median_salary_min ? `${this.currency} ${this.formatNumber((company.median_salary_min) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(company.median_salary_max * this.target_currency_rate)}` : "N/A";

      } else {
        company.median_salary = company.median_salary_min ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((company.median_salary_min) * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(company.median_salary_max * this.target_currency_rate)}` : "N/A";
      }

      return company;
    });
    // this.getJobsAggregates();
    this.getcompanydataai(this.comapniesSortData);
  }

  clearCurrency() {
    this.selectedCurrency = null;
    this.currency = null;
    this.filteredCurrencies = this.currencyData.slice(0, 5);
  }

  getCurrencyData(source?: string) {
    const filterData = this.filterDataHandlerService.fetchFilterData;
    const aggReq = this.aggService.getRequestWithFilters();

    if (filterData && filterData.locationSelectedList.length > 0) {
      if (source === 'filterChange') {
        const locations = filterData.locationSelectedList.map(loc => loc.key.replace('.searchastext', ''));
        const location = locations.join(',');
        const payload = { locations: locations }
        this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
          if (res.status === 'success' && res.data) {
            this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
            this.localstorageservice.setItem('currencyCountry', res.data.country_name);
            this.setUpdatedData();
          }
        })
      } else {
        this.currency = this.localstorageservice.getItem('jobCurrency');
        this.setUpdatedData()
      }
    } else if (this.jdService.isComingFromJobDescription) {
      if (source === 'jdUpdate') {
        if (aggReq && aggReq?.job_description_keys && aggReq?.job_description_keys?.locations?.length > 0) {
          const locations = aggReq.job_description_keys?.locations;
          const payload = { locations: locations }
          this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
            if (res.status === 'success' && res.data) {
              this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
              this.localstorageservice.setItem('currencyCountry', res.data.country_name);
              this.setUpdatedData();
            }
          })
        }
      } else {

        this.currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
        this.setUpdatedData();
      }


    } else {
      this.currency = this.localstorageservice.getItem('jobCurrency');
      this.setUpdatedData();
    }

  }

  formatNumberIndian(number: number): string | number {
    if (!number) return 0;

    const absNum = Math.abs(number);

    if (absNum >= 1e7) {
      return (number / 1e7).toFixed(1) + 'Cr';
    }

    if (absNum >= 1e5) {
      return (number / 1e5).toFixed(1) + 'L';
    }

    if (absNum >= 1e3) {
      return (number / 1e3).toFixed(1) + 'K';
    }

    return number.toString();
  }

  /**
   * Retrun true if data is still pending
   */
  getDataPendingStatus() {
    return this.hasMedianSalary || this.hasJobDemand;
  }

  setcompanyJobAggregates() {
    const aggReq = this.aggService.getRequestWithFilters();
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    if (skills?.length > 0 && jobtitles?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.comapniesSortData.map(company => {
          company.median_salary = "N/A";
          company.confidence_score = "N/A";
          company.job_doc_count = 0;
          return company;
        });
      } else {
        this.comapniesSortData.map(company => {
          const medianSalaryData = this.companyJobAggregates?.find(item => item.key.toLowerCase().trim() === company.key.toLowerCase().trim());
          if (medianSalaryData) {
            if (this.target_fav_icon == 'fa-money-bill') {
              company.median_salary = medianSalaryData.median_salary_min.value ? `${this.currency} ${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate)}` : "N/A";

            } else {
              company.median_salary = medianSalaryData.median_salary_min.value ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate)}` : "N/A";

            }
            company.median_salary_min = medianSalaryData.median_salary_min.value;
            company.median_salary_max = medianSalaryData.median_salary_max.value;
            company.confidence_score = medianSalaryData.confidence_score;
            company.job_doc_count = medianSalaryData?.job_demand?.doc_count || 0;
          } else {
            company.median_salary = "N/A";
            company.confidence_score = "N/A";
            company.job_doc_count = 0;
          }
          return company;
        });
      }
    } else {
      this.comapniesSortData.map(company => {
        company.median_salary = "N/A";
        company.confidence_score = "N/A";
        company.job_doc_count = 0;
        return company;
      });
    }


  }
  openJoblistSlider(value:any){
    Object.assign(this.companyTabPayload, {mandatory_companies:[value]})
      this.sendDataToSliderSubject.next(this.companyTabPayload);

      this.toOpenSliderFromTabSubject.next({isOpen:true})
  }
}
